import type { InjectionKey } from "vue";

export const vcPopoverKey: InjectionKey<VcPopoverContextType> = Symbol("vc-popover-context");
